import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { generateReactKey } from '../../utils/shared/commonUtils';

const RadioGroup = ({
    innerRef,
    id,
    values,
    radioGroupClassName,
    radioBtnClassName,
    hasLabel,
    onSelect,
    groupName,
    isDisabled,
    defaultValue,
}) => {
    const [selectedValue, setSelectedValue] = useState(defaultValue);

    useEffect(() => {
        setSelectedValue(defaultValue);
    }, [defaultValue]);

    return (
        <div id={id} className={`amplify-radio-group ${radioGroupClassName}`} ref={innerRef}>
            {values.map(value => (
                <div
                    key={generateReactKey(value)}
                    className={`amplify-radio-btn ${radioBtnClassName}`}
                >
                    <label htmlFor={`${value}_${groupName}`}>
                        <input
                            id={`${value}_${groupName}`}
                            type="radio"
                            name={groupName}
                            value={value}
                            checked={value === selectedValue}
                            disabled={isDisabled}
                            onChange={event => {
                                onSelect(event.target.value);
                            }}
                        />
                        <div className="faux-input" />
                        {hasLabel && <span>{value}</span>}
                    </label>
                </div>
            ))}
        </div>
    );
};

RadioGroup.defaultProps = {
    innerRef: null,
    id: null,
    values: [],
    defaultValue: '',
    radioGroupClassName: '',
    radioBtnClassName: '',
    hasLabel: true,
    onSelect: () => {},
    groupName: 'group',
    isDisabled: false,
};

RadioGroup.propTypes = {
    innerRef: PropTypes.object,
    id: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.string),
    defaultValue: PropTypes.string,
    radioGroupClassName: PropTypes.string,
    radioBtnClassName: PropTypes.string,
    hasLabel: PropTypes.bool,
    onSelect: PropTypes.func,
    groupName: PropTypes.string,
    isDisabled: PropTypes.bool,
};

export default forwardRef((props, ref) => <RadioGroup innerRef={ref} {...props} />);
